import { ApiResponse, useFetch } from '@/api/useFetch';
import CONSTANTS from '@/helpers/constants';
import { getProperQueryString } from '@/helpers/utils';
import type { StatsApiResponse, StatsZeblineAovResponse, StatsZeblineLtvResponse } from '@/pages/Stats/Stats.types';
import {
  FailedAttemptsLoginQueryParams,
  FailedAttemptsLoginResponse,
} from '@/pages/Stats/components/FailedAttemptsLogin/FailedAttemptsLogin.types';
import {
  LastSuccessLoginQueryParams,
  LastSuccessLoginResponse,
} from '@/pages/Stats/components/LastSuccessLogin/LastSuccessLogin.types';
import { ApiMethod } from '@/types/enums';

const { STATS } = CONSTANTS.API_ENTITY_URLS;

export const useGetStats = async (): Promise<ApiResponse<StatsApiResponse>> => {
  return await useFetch(`api/${STATS}`, {
    method: ApiMethod.Get,
  });
};

export const useGetStatsLastSuccess = async (
  query: LastSuccessLoginQueryParams,
): Promise<ApiResponse<LastSuccessLoginResponse>> => {
  return await useFetch(`api/${STATS}/authentication-activities/last-success?${getProperQueryString(query)}`, {
    method: ApiMethod.Get,
    noToast: true,
  });
};

export const useGetStatsFailedAttempts = async (
  query: FailedAttemptsLoginQueryParams,
): Promise<ApiResponse<FailedAttemptsLoginResponse>> => {
  return await useFetch(`api/${STATS}/authentication-activities/failed-attempts?${getProperQueryString(query)}`, {
    method: ApiMethod.Get,
    noToast: true,
  });
};

export const useGetStatsZeblineLTV = async (): Promise<ApiResponse<StatsZeblineLtvResponse>> => {
  return await useFetch(`api/${STATS}/zebline/ltv`, {
    method: ApiMethod.Get,
    noToast: true,
  });
};

export const useGetStatsZeblineAOV = async (): Promise<ApiResponse<StatsZeblineAovResponse>> => {
  return await useFetch(`api/${STATS}/zebline/aov`, {
    method: ApiMethod.Get,
    noToast: true,
  });
};

export const useGetRecordingStats = async (): Promise<ApiResponse<unknown>> => {
  return await useFetch(`api/${STATS}/recordings`, {
    method: ApiMethod.Get,
  });
};

export const useGetFileStats = async (): Promise<ApiResponse<unknown>> => {
  return await useFetch(`api/${STATS}/files`, {
    method: ApiMethod.Get,
  });
};

export const useGetChannelStats = async (): Promise<ApiResponse<unknown>> => {
  return await useFetch(`api/${STATS}/channels`, {
    method: ApiMethod.Get,
  });
};

export const useGetUserStats = async (): Promise<ApiResponse<unknown>> => {
  return await useFetch(`api/${STATS}/users`, {
    method: ApiMethod.Get,
  });
};

export const useGetExtraUserInformationStats = async (): Promise<ApiResponse<unknown>> => {
  return await useFetch(`api/${STATS}/extra-information-status`, {
    method: ApiMethod.Get,
  });
};
